/* BloomingFlower native cart drawer (Oct 19, 2026). Replaces the PageFly Smart Cart.
   - Opens after any successful add to cart (fetch to /cart/add) and from the header "Bag" link.
   - Contents: sections/bf-cart-drawer.liquid via the Section Rendering API, so prices, discounts and
     totals are Shopify's own. "Pairs well with": sections/bf-cart-recs.liquid via /recommendations/products.
   - Quantity, remove, add-ons and discount codes use the standard cart endpoints (/cart/change.js,
     /cart/add.js, /cart/update.js), so Shopify's add-to-cart customer events (Meta/GA4 pixels) still fire.
   - Does nothing while the PageFly Smart Cart is on the page, and nothing on /cart. */
(function () {
  if (window.__bfCd) return; window.__bfCd = 1;
  var d = document, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var dlg = d.getElementById('bf-cd');
  if (!dlg || /\/cart\/?$/.test(location.pathname)) return;
  var body = dlg.querySelector('[data-bf-cd-body]');
  var SECTION = 'bf-cart-drawer', loaded = false, self = 0, recsCache = {}, lastFocus = null, closeT = 0;

  /* PageFly Smart Cart present? Its app embed prints #smart-cart-config and the boot script into the HTML,
     so this is true from the first moment, before Smart Cart has built #smart-cart-host (no early-tap race). */
  function pf() { return !!(d.getElementById('smart-cart-host') || window.__SMART_CART_RUNTIME__ || d.getElementById('smart-cart-config') || d.querySelector('script[src*="pagefly-smart-cart"]')); }
  function on() { if (pf()) return false; d.documentElement.classList.add('bf-cd-on'); return true; }
  function api(url, data) {
    self++;
    var opt = data ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) } : { credentials: 'same-origin' };
    try { return window.fetch(url, opt); } finally { self--; }
  }
  function sectionHtml(html) {
    var t = d.createElement('template'); t.innerHTML = html || '';
    var w = t.content.querySelector('.shopify-section');
    return w ? w.innerHTML : t.innerHTML;
  }
  function counts(n) {
    d.querySelectorAll('[data-bfl-cart-count],[data-bfn-count],[data-bfr-cart-count],#bfv-cart-count,.bf-count').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    d.querySelectorAll('a.cart-button[data-bfl-cart-label]').forEach(function (a) { a.setAttribute('aria-label', a.getAttribute('data-bfl-cart-label') + ': ' + n); });
  }
  function paint(html) {
    if (html == null) return;
    var scroll = body.querySelector('.bf-cd__scroll'), top = scroll ? scroll.scrollTop : 0;
    var openCode = body.querySelector('.bf-cd__code[open]');
    body.innerHTML = sectionHtml(html);
    loaded = true;
    var panel = body.querySelector('[data-bf-cd-count]');
    if (panel) counts(panel.getAttribute('data-bf-cd-count'));
    if (openCode) { var c = body.querySelector('.bf-cd__code'); if (c) c.open = true; }
    scroll = body.querySelector('.bf-cd__scroll'); if (scroll) scroll.scrollTop = top;
    if (dlg.open && !dlg.contains(d.activeElement)) { var x = body.querySelector('[data-bf-cd-close]'); if (x) x.focus({ preventScroll: true }); }
    recs();
    codes();
  }
  /* Codes that are entered but don't apply to the current items (e.g. BLACKFRIDAY15 on excluded items) aren't in Liquid's
     discount_applications, so list them from /cart.js as "not applied" with a remove button. */
  function codes() {
    var ul = body.querySelector('[data-bf-cd-chips]'); if (!ul) return;
    var applied = (ul.getAttribute('data-applied') || '').toUpperCase().split('|');
    api(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!d.contains(ul)) return;
      (c.discount_codes || []).forEach(function (x) {
        if (x.applicable || applied.indexOf(String(x.code).toUpperCase()) >= 0) return;
        var li = d.createElement('li'); li.className = 'is-off';
        li.innerHTML = '<span></span><em>not applied to these items</em><button type="button" data-bf-cd-uncode aria-label="Remove discount code">&times;</button>';
        li.firstChild.textContent = x.code; ul.appendChild(li);
        var det = ul.closest('details'); if (det) det.open = true;
      });
    }).catch(function () {});
  }
  function load() {
    return api(root + '?sections=' + SECTION).then(function (r) { return r.json(); }).then(function (j) { paint(j[SECTION]); }).catch(function () {});
  }
  function recs() {
    var box = body.querySelector('[data-bf-cd-recs]');
    if (!box) return;
    var pid = box.getAttribute('data-pid'); if (!pid) return;
    var key = pid + ':' + box.getAttribute('data-sig');
    var fill = function (html) { var h = sectionHtml(html).trim(); if (h) { box.innerHTML = h; box.hidden = false; } };
    if (recsCache[key] != null) return fill(recsCache[key]);
    api(root + 'recommendations/products?section_id=bf-cart-recs&limit=8&intent=related&product_id=' + encodeURIComponent(pid))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { recsCache[key] = t; if (d.contains(box)) fill(t); })
      .catch(function () {});
  }
  function lock(v) {
    var de = d.documentElement;
    if (v) { var sb = window.innerWidth - de.clientWidth; if (sb > 0) de.style.paddingRight = sb + 'px'; de.classList.add('bf-cd-lock'); }
    else { de.classList.remove('bf-cd-lock'); de.style.paddingRight = ''; }
  }
  function open() {
    if (!on()) return false;
    clearTimeout(closeT);
    if (!dlg.open) {
      lastFocus = d.activeElement;
      lock(true);
      dlg.showModal();
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
      var x = dlg.querySelector('[data-bf-cd-close]'); if (x) x.focus({ preventScroll: true });
    }
    return true;
  }
  function close() {
    if (!dlg.open) return;
    dlg.classList.remove('is-open');
    var done = function () { if (!dlg.classList.contains('is-open') && dlg.open) { dlg.close(); } };
    closeT = setTimeout(done, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320);
  }
  dlg.addEventListener('close', function () { dlg.classList.remove('is-open'); lock(false); if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {} });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-bf-cd-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-bf-cd-qty]');
    if (q && !q.disabled) {
      var li = q.closest('[data-key]');
      busy(true);
      api(root + 'cart/change.js', { id: li.getAttribute('data-key'), quantity: +q.getAttribute('data-bf-cd-qty'), sections: SECTION })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) { if (x.ok && x.j.sections) { paint(x.j.sections[SECTION]); } else { err(x.j && (x.j.description || x.j.message)); busy(false); } })
        .catch(function () { err(); busy(false); });
      return;
    }
    if (e.target.closest('[data-bf-cd-uncode]')) { code(''); }
  });
  dlg.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-bf-cd-add]')) {
      e.preventDefault();
      var b = f.querySelector('button'), sel = f.querySelector('[name=id]'), id = sel.value;
      if (!id) { sel.focus(); sel.classList.add('is-need'); return; }
      b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding\u2026';
      api(root + 'cart/add.js', { items: [{ id: +id, quantity: 1 }], sections: SECTION })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (x.ok && x.j.sections) paint(x.j.sections[SECTION]);
          else { b.removeAttribute('aria-busy'); b.textContent = 'Add'; err(x.j && (x.j.description || x.j.message)); }
        })
        .catch(function () { b.removeAttribute('aria-busy'); b.textContent = 'Add'; err(); });
    } else if (f.matches('[data-bf-cd-code]')) {
      e.preventDefault();
      var v = (f.querySelector('input').value || '').trim();
      if (v) code(v);
    }
  });
  function code(v) {
    busy(true);
    api(root + 'cart/update.js', { discount: v, sections: SECTION })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.sections) paint(j.sections[SECTION]);
        var bad = v && (j.discount_codes || []).some(function (c) { return c.code.toUpperCase() === v.toUpperCase() && !c.applicable; });
        var m = body.querySelector('[data-bf-cd-code-msg]');
        if (m && bad) m.textContent = v.toUpperCase() + ' doesn\u2019t apply to the items in your cart right now.';
      })
      .catch(function () { err(); busy(false); });
  }
  function busy(v) { var p = body.querySelector('[data-bf-cd-count]'); if (p) { if (v) p.setAttribute('aria-busy', 'true'); else p.removeAttribute('aria-busy'); } }
  function err(msg) { var e = body.querySelector('[data-bf-cd-err]'); if (e) { e.textContent = msg || 'Something went wrong. Please try again.'; e.hidden = false; } }

  /* Open after any add to cart made elsewhere on the page (product forms, quick add, set boxes, page cards). */
  var f0 = window.fetch;
  if (f0) window.fetch = function (input) {
    var p = f0.apply(this, arguments);
    if (!self) {
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        var path = u.replace(location.origin, '').split('?')[0].split('#')[0];
        if (/\/cart\/add(\.js|\.json)?$/.test(path)) {
          p.then(function (r) { if (r && r.ok && on()) { open(); load(); } }).catch(function () {});
        } else if (/\/cart\/(change|update|clear)(\.js|\.json)?$/.test(path)) {
          p.then(function (r) { if (r && r.ok && loaded) load(); }).catch(function () {});
        }
      } catch (e) {}
    }
    return p;
  };

  /* Header "Bag" link opens the drawer instead of going to /cart. */
  function isCartLink(a) {
    if (!a || a.target === '_blank') return false;
    var path; try { path = new URL(a.href, location.href).pathname; } catch (e) { return false; }
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(path)) return false;
    return !!(a.matches('.cart-button,[data-bfl-cart-label],.bfn-icon') || a.closest('header,#header-group,.header,[class*="header"]'));
  }
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!isCartLink(a) || pf()) return;
    e.preventDefault();
    if (open()) load();
  });
  /* Warm the drawer when someone is about to open it. */
  function warm(e) { var a = e.target.closest && e.target.closest('a[href]'); if (!loaded && isCartLink(a) && !pf()) { loaded = true; load(); } }
  d.addEventListener('pointerover', warm, { passive: true });
  d.addEventListener('touchstart', warm, { passive: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted && loaded) load(); });
})();
